// Invoice Number Generation Utility
// Format: {matterCode}/INV–{sequential}.{year suffix}
// Example: L/031/22/INV–004.26

const STORAGE_KEY = 'remington_invoice_counter';
const INVOICES_KEY = 'remington_invoices';

// Get current year's last two digits
export const getCurrentYearSuffix = () => {
  return new Date().getFullYear().toString().slice(-2);
};

// Get next sequential number
export const getNextSequentialNumber = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  let counter = stored ? parseInt(stored, 10) : 0;
  counter += 1;
  localStorage.setItem(STORAGE_KEY, counter.toString());
  return counter;
};

// Peek at next number without incrementing
export const peekNextSequentialNumber = () => {
  const stored = localStorage.getItem(STORAGE_KEY);
  return stored ? parseInt(stored, 10) + 1 : 1;
};

// Format sequential number with leading zeros (3 digits)
export const formatSequentialNumber = (num) => {
  return num.toString().padStart(3, '0');
};

// Generate full invoice number
export const generateInvoiceNumber = (matterCode, type = 'INV') => {
  const seq = getNextSequentialNumber();
  const yearSuffix = getCurrentYearSuffix();
  const formattedSeq = formatSequentialNumber(seq);
  
  // Type can be INV (Invoice), DFT (Draft), or OUT (Outlay)
  return `${matterCode}/${type}–${formattedSeq}.${yearSuffix}`;
};

// Generate invoice number without incrementing
export const previewInvoiceNumber = (matterCode, type = 'INV') => {
  const seq = peekNextSequentialNumber();
  const yearSuffix = getCurrentYearSuffix();
  const formattedSeq = formatSequentialNumber(seq);
  
  return `${matterCode}/${type}–${formattedSeq}.${yearSuffix}`;
};

// Save invoice to storage
export const saveInvoice = (invoice) => {
  const invoices = getInvoices();
  invoices.push({
    ...invoice,
    id: Date.now(),
    createdAt: new Date().toISOString()
  });
  localStorage.setItem(INVOICES_KEY, JSON.stringify(invoices));
  return invoice;
};

// Get all invoices
export const getInvoices = () => {
  const stored = localStorage.getItem(INVOICES_KEY);
  return stored ? JSON.parse(stored) : [];
};

// Get invoice by number
export const getInvoiceByNumber = (invoiceNumber) => {
  const invoices = getInvoices();
  return invoices.find(inv => inv.invoiceNumber === invoiceNumber);
};

// Reset counter (admin function)
export const resetCounter = (newValue = 0) => {
  localStorage.setItem(STORAGE_KEY, newValue.toString());
};

// Format currency
export const formatCurrency = (amount) => {
  return new Intl.NumberFormat('en-KE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(amount);
};

// Format date
export const formatDate = (date) => {
  const d = new Date(date);
  const options = { year: 'numeric', month: 'long', day: 'numeric' };
  return d.toLocaleDateString('en-US', options);
};

// Calculate VAT (16% in Kenya)
export const calculateVAT = (professionalFees, vatRate = 16) => {
  return (professionalFees * vatRate) / 100;
};

// Calculate grand total
export const calculateGrandTotal = (professionalFees, outlays, vatAmount) => {
  return professionalFees + outlays + vatAmount;
};
